/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdateUserAccountName200ResponseReissueOneOf
 */
export interface UpdateUserAccountName200ResponseReissueOneOf {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserAccountName200ResponseReissueOneOf
     */
    'cardType': UpdateUserAccountName200ResponseReissueOneOfCardTypeEnum;
    /**
     * Expiration date of the previous virtual card that was replaced by automatic reissuance.
     * @type {string}
     * @memberof UpdateUserAccountName200ResponseReissueOneOf
     */
    'expiredDate': string;
}

export const UpdateUserAccountName200ResponseReissueOneOfCardTypeEnum = {
    virtual: 'virtual'
} as const;

export type UpdateUserAccountName200ResponseReissueOneOfCardTypeEnum = typeof UpdateUserAccountName200ResponseReissueOneOfCardTypeEnum[keyof typeof UpdateUserAccountName200ResponseReissueOneOfCardTypeEnum];


